import RemoveCIDModal from './RemoveCIDModal';

export default RemoveCIDModal;
